import WithRender from "../../templates/base/summarySelectedPageOptions.html";
import { mapGetters } from "vuex";
import { i18n } from "../../i18n.js";

export default WithRender({
  computed: {
    ...mapGetters([
      "getSummarySelectedPageOptions",
      "getIsSummaryPageOptionActive"
    ]),
    name: () => {
      return i18n.t("Product overview");
    }
  }
});
